<template>
  <div style="width: 60%" class="cookie-container">
    <CCard v-if="visible">
      <CCardBody>
        <CRow :gutters="true">
          <CCol sm="8">
            <CRow>
              <CCol style="flex: 0 0 1.5em" class="">
                <CIcon name="cookie" size="custom-size" :height="24" viewBox="0 0 32 32" />
              </CCol>
              <CCol>
                <CRow>
                  <CCol class="font-weight-bold"> {{ $t('cookie.panel.title') }} </CCol>
                </CRow>
                <CRow>
                  <CCol class="content-cookie">{{ $t('cookie.panel.content') }}</CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>
          <CCol sm="3" class="text-center pr-4" style="align-self: center">
            <CButton style="width: 100%" color="primary" variant="outline" @click="acceptCookies()">{{ $t('cookie.panel.buttonAceitar') }}</CButton>
          </CCol>
          <CCol class="text-right border-close py-3" style="align-self: center" sm="1">
            <div style="display: inline-block" @click="closeClick()">
              <CIcon name="cross" size="custom-size" style="cursor: pointer" :height="12" viewBox="0 0 32 32" />
            </div>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
    }
  },
  mounted() {
    var accept = this.$cookie.get('acceptCookies')
    if (!accept) this.visible = true
  },
  methods: {
    closeClick() {
      this.visible = false
      // temporário
      sessionStorage.setItem('useCookie', 'false')
    },
    acceptCookies() {
      this.$cookie.set('acceptCookies', true, { expires: 999 })
      this.visible = false
    },
  },
}
</script>

<style lang="scss">
.content-cookie {
  font-size: $font-size-xs;
}

.border-close {
  border-left: 2px solid $gray-200;
}

.cookie-container {
  position: fixed;
  bottom: 0;
  z-index: 1001;
}
</style>
